"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssuredType = exports.eAssuredType = void 0;
const utils_1 = require("@loadsure/utils");
const assured_class_1 = __importDefault(require("./assured.class"));
var eAssuredType;
(function (eAssuredType) {
    eAssuredType["SHIPPER"] = "SHIPPER";
    eAssuredType["RECIPIENT"] = "RECIPIENT";
    eAssuredType["BUYER"] = "BUYER";
    eAssuredType["SELLER"] = "SELLER";
})(eAssuredType = exports.eAssuredType || (exports.eAssuredType = {}));
var AssuredType;
(function (AssuredType) {
    const data = {
        [eAssuredType.SHIPPER]: "Shipper",
        [eAssuredType.RECIPIENT]: "Recipient",
        [eAssuredType.BUYER]: "Buyer",
        [eAssuredType.SELLER]: "Seller"
    };
    function getItems() {
        return utils_1.objectToItems(data);
    }
    AssuredType.getItems = getItems;
})(AssuredType = exports.AssuredType || (exports.AssuredType = {}));
exports.default = assured_class_1.default;
//# sourceMappingURL=index.js.map